//---------------------------------
// is editable race characteristic
//---------------------------------
export default function isEditableRaceCharacteristic(field) {

  const editableSuffixes = ['_improvs_tot', '_rolled']
  
  return editableSuffixes.some(suffix => field.endsWith(suffix))
}
